
import axios from "axios";
const API_URL = "https://api2.ccmbtareas.com/";

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});


apiClient.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("authUser").token;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


